import React, { useState } from 'react';
import { MessageSquare, Mail, Phone, MapPin, Send, CheckCircle2, Clock, Sparkles } from 'lucide-react';
import { trackWhatsAppClick, sendContactMessage } from '../services/adminStorage';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    category: 'Artesanato & Handcrafted',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showEmail, setShowEmail] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await sendContactMessage(formData);
      setSubmitted(true);
    } catch (err) {
      console.error('Erro ao enviar mensagem:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const openWhatsApp = () => {
    trackWhatsAppClick();
    const text = encodeURIComponent('Olá, Suzume Technologies! Vim pelo formulário de contato do site e gostaria de falar com um atendente.');
    window.open(`https://wa.me/5511932654166?text=${text}`, '_blank');
  };

  return (
    <div className="section-padding" style={{ minHeight: '80vh', backgroundColor: 'var(--bg-main)' }}>
      <div className="container">
        
        {/* Banner Contato */}
        <div className="text-center" style={{ maxWidth: '750px', margin: '0 auto 2.5rem' }}>
          <div className="badge badge-brand" style={{ marginBottom: '0.75rem' }}>
            <Sparkles size={14} />
            Atendimento Suzume Technologies
          </div>
          <h1 style={{ fontSize: '2.5rem', color: 'var(--text-title)', marginBottom: '0.75rem' }}>
            Entre em Contato Conosco
          </h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.05rem' }}>
            Tem alguma dúvida sobre nosso catálogo ou planos de assinatura? Fale diretamente com nossa equipe no WhatsApp ou envie uma mensagem abaixo.
          </p>
        </div>

        <div className="contact-grid">
          {/* Card de Informações e WhatsApp */}
          <div className="contact-info-card">
            <div>
              <img 
                src="/img/logo_suzume_horizontal.png" 
                alt="Suzume Technologies Logo" 
                style={{ height: '44px', marginBottom: '1.5rem', filter: 'brightness(0) invert(1)' }}
                onError={(e) => e.target.style.display = 'none'}
              />
              <h3 style={{ fontSize: '1.5rem', color: '#ffffff', marginBottom: '1rem' }}>
                Fale com um Especialista
              </h3>
              <p style={{ fontSize: '0.95rem', color: '#cbd5e1', marginBottom: '2rem', lineHeight: '1.6' }}>
                Estamos à disposição para ajudar você a escolher o melhor modelo de landing page para alavancar a presença online da sua empresa.
              </p>

              {/* Botão WhatsApp em Destaque */}
              <div style={{ background: 'rgba(255, 255, 255, 0.08)', padding: '1.5rem', borderRadius: '14px', border: '1px solid rgba(255, 255, 255, 0.15)', marginBottom: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                  <MessageSquare size={24} color="#25d366" />
                  <span style={{ fontWeight: 700, fontSize: '1.05rem', color: '#ffffff' }}>WhatsApp Instantâneo</span>
                </div>
                <p style={{ fontSize: '0.85rem', color: '#94a3b8', marginBottom: '1.25rem' }}>
                  Atendimento direto e sem espera de segunda a sexta.
                </p>
                <button className="btn btn-whatsapp" onClick={openWhatsApp} style={{ width: '100%' }}>
                  <MessageSquare size={18} />
                  Falar Agora no WhatsApp
                </button>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', fontSize: '0.95rem', color: '#cbd5e1' }}>
                  <Mail size={18} color="#3a86ff" />
                  {showEmail ? (
                    <a href="mailto:contato@suzumetech.com.br" style={{ color: '#cbd5e1', textDecoration: 'none' }}>
                      contato@suzumetech.com.br
                    </a>
                  ) : (
                    <button 
                      onClick={() => setShowEmail(true)} 
                      style={{ 
                        background: 'rgba(58, 134, 255, 0.15)', 
                        border: '1px solid rgba(58, 134, 255, 0.3)', 
                        color: '#3a86ff', 
                        borderRadius: '6px', 
                        padding: '0.25rem 0.65rem', 
                        fontSize: '0.85rem', 
                        cursor: 'pointer',
                        fontWeight: 600,
                        transition: 'all 0.2s ease'
                      }}
                    >
                      Ver e-mail
                    </button>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', fontSize: '0.95rem', color: '#cbd5e1' }}>
                  <Phone size={18} color="#3a86ff" />
                  <span>(11) 93265-4166</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', fontSize: '0.95rem', color: '#cbd5e1' }}>
                  <Clock size={18} color="#3a86ff" />
                  <span>Segunda a Sexta: 08:00 às 18:00</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', fontSize: '0.95rem', color: '#cbd5e1' }}>
                  <MapPin size={18} color="#3a86ff" />
                  <span>São Paulo, SP - Brasil</span>
                </div>
              </div>
            </div>

            <div style={{ marginTop: '2.5rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.1)', fontSize: '0.85rem', color: '#94a3b8' }}>
              Suzume Technologies - Inovação e Design em Landing Pages.
            </div>
          </div>

          {/* Formulário de Envio de Mensagem */}
          <div className="contact-form-card">
            <h3 style={{ fontSize: '1.5rem', color: 'var(--text-title)', marginBottom: '0.5rem' }}>
              Envie sua Mensagem
            </h3>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', marginBottom: '1.5rem' }}>
              Preencha o formulário abaixo e entraremos em contato o mais breve possível.
            </p>

            {submitted ? (
              <div style={{ 
                padding: '2rem', 
                backgroundColor: 'rgba(16, 185, 129, 0.1)', 
                border: '1px solid var(--color-success)', 
                borderRadius: '12px', 
                textAlign: 'center',
                color: 'var(--color-success)',
                animation: 'fadeIn 0.3s ease'
              }}>
                <CheckCircle2 size={48} style={{ margin: '0 auto 1rem' }} />
                <h4 style={{ fontSize: '1.25rem', marginBottom: '0.5rem', color: 'var(--text-title)' }}>
                  Mensagem enviada com sucesso!
                </h4>
                <p style={{ color: 'var(--text-body)', fontSize: '0.95rem' }}>
                  Obrigado pelo contato! Nossa equipe responderá em breve através do e-mail ou WhatsApp informado.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label" htmlFor="name">Seu Nome Completo *</label>
                  <input 
                    type="text" 
                    id="name"
                    name="name"
                    required
                    placeholder="Ex: João da Silva"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div>
                    <label className="form-label" htmlFor="email">E-mail Corporativo *</label>
                    <input 
                      type="email" 
                      id="email"
                      name="email"
                      required
                      placeholder="seuemail@empresa.com"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  <div>
                    <label className="form-label" htmlFor="phone">Telefone / WhatsApp *</label>
                    <input 
                      type="tel" 
                      id="phone"
                      name="phone"
                      required
                      placeholder="(11) 99999-9999"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="category">Nicho de Mercado / Categoria de Interesse</label>
                  <select 
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="Artesanato & Handcrafted">Artesanato & Handcrafted</option>
                    <option value="Mecânica & Automotivo">Mecânica & Automotivo</option>
                    <option value="Saúde & Bem-Estar">Saúde & Bem-Estar</option>
                    <option value="Gastronomia & Confeitaria">Gastronomia & Confeitaria</option>
                    <option value="Advocacia & Direito">Advocacia & Direito</option>
                    <option value="Beleza & Estética">Beleza & Estética</option>
                    <option value="Arquitetura & Construção">Arquitetura & Construção</option>
                    <option value="Educação & Cursos">Educação & Cursos</option>
                    <option value="Imobiliária & Corretagem">Imobiliária & Corretagem</option>
                    <option value="Outro Nicho / Sob Medida">Outro Nicho / Sob Medida</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="message">Sua Mensagem *</label>
                  <textarea 
                    id="message"
                    name="message"
                    required
                    placeholder="Conte-nos um pouco sobre o seu projeto ou dúvidas sobre os modelos..."
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control"
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={isSubmitting}>
                  <Send size={18} />
                  {isSubmitting ? 'Enviando mensagem...' : 'Enviar Mensagem'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
